var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Initialize and add the map
let map;
function initMap() {
    return __awaiter(this, void 0, void 0, function* () {
        // Import maps library
        const { Map } = (yield google.maps.importLibrary("maps"));
        // Import marker library
        const { AdvancedMarkerElement, PinElement } = (yield google.maps.importLibrary("marker"));
        // Import core library
        const { ColorScheme } = (yield google.maps.importLibrary("core"));
        const maps = document.querySelectorAll(".custom-map");
        for (let i = 0; i < maps.length; i++) {
            let el = maps[i];
            let mapId = el.id, mapLat = parseFloat(el.dataset.latitude), mapLong = parseFloat(el.dataset.longitude), mapZoom = parseFloat(el.dataset.zoom) || 15, mapStyle = el.dataset.style, markerColor = el.dataset.color, markerContent = el.dataset.content, markerCircle = el.dataset.circle, markerIcon = el.dataset.icon, markerSize = el.dataset.size;
            let position = { lat: mapLat, lng: mapLong };
            let markerEl;
            if (markerContent === "image") {
                markerEl = `<div class="marker-img" style="background-image:url(${markerIcon});background-size:${markerSize};"></div>`;
            }
            else {
                markerEl = `<div class="marker-circle" style="background-color:${markerCircle};"></div>`;
            }
            // Define map paramaters
            map = new Map(el, {
                zoom: mapZoom,
                center: position,
                mapId: mapId,
                colorScheme: ColorScheme[mapStyle],
            });
            // Create marker element
            const customMapMarker = document.createElement("div");
            customMapMarker.className = "map-marker";
            customMapMarker.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="${markerColor}" width="50" height="67" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"/></svg>`;
            customMapMarker.innerHTML += markerEl;
            // Define marker paramaters
            const marker = new AdvancedMarkerElement({
                map,
                position: position,
                content: customMapMarker,
                // title: "Hello from Meta Digital!",
            });
        }
    });
}
initMap();
